// Client-side ULID generator. Matches the server's
// ^[0-9A-HJKMNP-TV-Z]{26}$ gate (Crockford base32): a 10-char
// millisecond-timestamp prefix + 16 random chars. Used wherever the
// client needs a stable id to hand the server for idempotency (sale ids,
// refund idempotency keys) so a retried request converges instead of
// duplicating.
const CROCKFORD = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';

export function newClientUlid(): string {
  const c = (globalThis as { crypto?: Crypto }).crypto;
  let time = '';
  let ms = Date.now();
  for (let i = 9; i >= 0; i--) {
    time = CROCKFORD[ms % 32] + time;
    ms = Math.floor(ms / 32);
  }
  let rand = '';
  if (c && typeof c.getRandomValues === 'function') {
    const bytes = new Uint8Array(16);
    c.getRandomValues(bytes);
    for (let i = 0; i < 16; i++) rand += CROCKFORD[bytes[i] % 32];
  } else {
    // Fallback only — getRandomValues is universally available in any
    // browser that runs the PWA.
    for (let i = 0; i < 16; i++)
      rand += CROCKFORD[Math.floor(Math.random() * 32)];
  }
  return time + rand;
}
